import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  scheduleListParams,
  scheduleListQueryOptions,
  scheduleListSearchSchema,
  SchedulesPage,
} from '@/features/schedules';

export const Route = createFileRoute('/_authed/_active/org/schedules/')({
  staticData: { tours: ['schedules.list'] },
  // Typed as the raw input so links into the list (`<Link to="/org/schedules">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    scheduleListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, deps, cause }) => {
    const prefetch = context.queryClient
      .query({ ...scheduleListQueryOptions(scheduleListParams(deps)), staleTime: 'static' })
      .catch(() => undefined);
    // A filter or page change on the list itself must not wait for the fetch.
    if (cause !== 'stay') await prefetch;
  },
  component: SchedulesPage,
});
